/**
 * Copyright (c) 2025 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Text, Header, ActionButton, Tooltip, BrandColors } from '@blend/enterprise-components';
import { cardWidth } from 'blb-styles/constants';

const styles = StyleSheet.create({
  cardContainer: {
    alignItems: 'flex-start',
    background: BrandColors.WHITE,
    border: `1px solid ${BrandColors.CLOUD_50}`,
    borderRadius: 6,
    display: 'flex',
    flexDirection: 'column',
    flexBasis: cardWidth,
    maxWidth: cardWidth,
    padding: `20px 24px`,
    marginBottom: 16,
  },
  header: {
    fontWeight: 600,
    marginBottom: 8,
  },
  buttonRow: {
    marginTop: 15,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
});

interface VerticalSectionCardProps {
  title: string;
  description?: React.ReactNode;
  buttonLabel?: string;
  onButtonClick?: () => void;
  disabled?: boolean;
  disabledReason?: string;
}

export const VerticalSectionCard: React.FC<VerticalSectionCardProps> = ({
  title,
  description,
  buttonLabel,
  onButtonClick,
  disabled,
  disabledReason,
}) => (
  <div className={css(styles.cardContainer)} data-testid="vertical-section-card">
    <Header className={css(styles.header)} size={5}>
      {title}
    </Header>
    {typeof description === 'string' ? <Text colorName="NIGHT_80">{description}</Text> : description}
    {buttonLabel && (
      <div className={css(styles.buttonRow)}>
        <Tooltip text={disabledReason}>
          <ActionButton disabled={disabled} label={buttonLabel} onClick={onButtonClick} />
        </Tooltip>
      </div>
    )}
  </div>
);
